import { createContext } from "react";

export const OrderContext = createContext([]);

export default OrderContext;
